var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "b-container",
        { staticClass: "flex-grow-1 d-flex flex-column", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "flex-grow-1 flex-column" },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex products flex-grow-1 flex-column",
                  attrs: { md: "12" }
                },
                [
                  _vm.tasks.length !== 0
                    ? _c(
                        "div",
                        { staticClass: "d-flex flex-grow-1" },
                        [
                          _vm.tasks.length !== 0
                            ? _c(
                                "b-card",
                                {
                                  staticClass:
                                    "flex-grow-1 grid grid-3 headGrid",
                                  attrs: {
                                    "no-body": "",
                                    "header-class": "py-2"
                                  }
                                },
                                _vm._l(_vm.paginatedData, function(
                                  productTask
                                ) {
                                  return _c("task-product-item", {
                                    key: productTask.id,
                                    attrs: {
                                      productTask: productTask,
                                      userRole: _vm.userRole,
                                      active: _vm.isActiveTask(productTask),
                                      spinning: _vm.isSpinning(productTask),
                                      selected: _vm.isSelectedTask(productTask)
                                    },
                                    on: {
                                      "task-clicked": function($event) {
                                        return _vm.selectTask(productTask)
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tasks.length === 0
                    ? _c(
                        "b-card",
                        { staticClass: "stubCenter", attrs: { "no-body": "" } },
                        [_c("h5", [_vm._v("Очередь заказов пуста")])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass: "footPad flex-shrink-0",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "w-100 h-100",
                              attrs: {
                                disabled: _vm.pageNumber === 0,
                                variant: "dark"
                              },
                              on: { click: _vm.prevPage }
                            },
                            [
                              _vm._v(
                                "Предыдущая страница\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-card", { staticClass: "pageInfo" }, [
                            _c("p", [
                              _vm._v(
                                "Страница " +
                                  _vm._s(_vm.pageNumber + 1) +
                                  " из (" +
                                  _vm._s(_vm.pageCount) +
                                  ")"
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "w-100 h-100",
                              attrs: {
                                variant: "dark",
                                disabled: _vm.pageNumber >= _vm.pageCount - 1
                              },
                              on: { click: _vm.nextPage }
                            },
                            [
                              _vm._v(
                                "Следующая страница\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "flex-shrink-0" },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "col-md-6 nullPad",
                          attrs: { "no-body": "", "header-class": "py-2" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _c("b", [
                                _vm._v(
                                  "Кол-во продуктов в очереди: " +
                                    _vm._s(_vm.tasks.length)
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          staticClass: "col-md-3",
                          attrs: {
                            variant: "danger",
                            disabled: !_vm.isSelectedTasks
                          },
                          on: { click: _vm.Cancel }
                        },
                        [_vm._v("Отмена выделения\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          staticClass: "col-md-3",
                          attrs: {
                            variant: "success",
                            disabled: !_vm.isSelectedTasks
                          },
                          on: {
                            click: function($event) {
                              return _vm.readyTask()
                            }
                          }
                        },
                        [_vm._v("Приготовлено\n                    ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d881b52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d881b52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListProducts.vue
// module id = null
// module chunks = 